import React from 'react'

/**
 * @desc Temp Stand-in Page
 */
const ComingSoon = () => {
  return (
    <>
      <div className='flex flex-col items-center justify-center h-screen'>
        <h1 className='text-4xl font-bold text-neutral-900'>Coming soon!</h1>
        <h2 className='text-2xl font-bold text-neutral-900'>Givu is still under development, check back with us later.</h2>
        <br />
        <button
          className='drop-shadow-pastel-yellow text-xl py-3 px-6 bg-slate-800 text-slate-100 rounded border-none hover:bg-inherit hover:text-slate-900 hover:underline'
          onClick={() => history.back()}
        >
          Go Back
        </button>
      </div>
    </>
  )
}

export default ComingSoon
